<template>
  <div class="flex space-x-6">
    <!-- buttons wrapper -->
    <div class="flex border border-grey-500 rounded max-w-xs w-full p-6">
      <div class="m-auto">
        <base-button
          @click.native="exportToPdf"
          :big="true"
          colorScheme="orange"
          class="mb-3"
        >
          <svg
            class="mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.4288 7V19.7142C19.4288 20.8188 18.5334 21.7142 17.4288 21.7142H7.14307C6.0385 21.7142 5.14307 20.8188 5.14307 19.7142V4.28564C5.14307 3.18107 6.0385 2.28564 7.14307 2.28564H15.0002M19.4288 7L15.0002 2.28564M19.4288 7H16.0002C15.4479 7 15.0002 6.55228 15.0002 6V2.28564M12.2859 8.85707V15.9999M12.2859 15.9999L15.1431 13.4285M12.2859 15.9999L9.14307 13.4285"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Export to PDF
        </base-button>
        <base-button :big="true" @click.native="handleClick">
          <svg
            class="mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.5523 9.5043L12 4.3331L9.44772 9.5043L3.74112 10.3336L7.87038 14.3588L6.89574 20.0425L12.0001 17.3589L17.1041 20.0424L16.1292 14.3588L20.2588 10.3336L14.5523 9.5043ZM1.43235 10.1777L6.25868 14.8825L5.1195 21.5257C5.07891 21.7622 5.17615 22.0011 5.37026 22.1422C5.48007 22.222 5.61013 22.2626 5.74082 22.2626C5.84118 22.2626 5.94187 22.2387 6.03407 22.1902L12 19.0536L17.9658 22.1901C18.1782 22.3018 18.4355 22.2832 18.6296 22.1422C18.8237 22.0011 18.921 21.7621 18.8805 21.5256L17.7409 14.8825L22.5678 10.1777C22.7396 10.0103 22.8015 9.75978 22.7273 9.53159C22.6531 9.30336 22.4559 9.13703 22.2185 9.10257L15.5484 8.13329L12.5653 2.08915C12.4591 1.87399 12.24 1.73779 12.0001 1.73779C11.7601 1.73779 11.541 1.87399 11.4348 2.08915L8.45165 8.13329L1.78165 9.10257C1.54426 9.13703 1.34695 9.30336 1.27283 9.53154C1.19865 9.75978 1.26051 10.0103 1.43235 10.1777Z"
              fill="currentColor"
            />
          </svg>

          To Shortlist
        </base-button>
      </div>
    </div>
    <!-- catalog detail -->
    <div
      class="
        flex
        items-start
        rounded
        bg-grey-400
        px-5
        pt-5
        pb-6
        bg-catalog bg-no-repeat bg-right-bottom
        w-full
      "
      :style="{ 'background-image': `url(${require('@/assets/book-bg.svg')})` }"
    >
      <img
        src="@/assets/new-catalogs/1.jpg"
        alt="Catalog name"
        class="shadow-md h-auto mr-6"
        width="134"
      />
      <div class="max-w-xl">
        <h2 class="text-black-900 font-medium text-2xl mb-2">Catalog Name</h2>
        <h3 class="text-grey-700 font-medium text-base mb-3">
          Epigram Bookshop
        </h3>
        <p class="text-black-600 text-sm mb-3">
          Longlisted for the Epigram Books Fiction Prize 2020. In
          post-independence Singapore, tradition clashes with modernity in this
          compelling tale of the importance of defining one's own story. When
          their father Sujakon comes home late one night, raving about bad
          people coming to take them away, siblings Zuzu and Hakeem are forced
          to leave everything behind and live in a tent at Changi Beach, with a
          secret community called Anak Bumi—the Children of the Earth.
        </p>
        <div class="flex space-x-10">
          <div>
            <h5 class="text-grey-700 text-sm">Added:</h5>
            <p class="text-black-600 text-sm">June 22, 2020</p>
          </div>
          <div>
            <h5 class="text-grey-700 text-sm">Updated:</h5>
            <p class="text-black-600 text-sm">May 22, 2021</p>
          </div>
        </div>
      </div>
      <router-link
        to="/"
        class="w-18 h-18 flex rounded bg-white-900 ml-auto p-1"
      >
        <img
          src="@/assets/popular-publishers/1.svg"
          alt="Publisher name"
          class="h-full object-contain m-auto max-w-60"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/utils/Button.vue";
export default {
  name: "CardCatalogDetail",
  components: {
    "base-button": BaseButton,
  },
  methods: {
    handleClick() {
      this.$modal.show("shortlist-modal", "add-shortlist-modal");
    },
    exportToPdf() {
      this.$emit("export-to-pdf");
    },
  },
};
</script>
